import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import {
    ErrorInterface,
    PolicyProductIdEnum,
    PolicyValidityStatusCodeEnum,
    PurchasedProductInterface,
} from 'outshared-lib';
import { KentekenPipe } from '@app/shared/pipes/kenteken.pipe';
import { CapitalizePipe } from '@app/shared/pipes/capitalize/capitalize.pipe';

@Component({
    selector: 'ins-insurance-imic-buttons',
    templateUrl: './insurance-imic-buttons.component.html',
    styleUrls: ['../insurance-imic.component.scss', './insurance-imic-buttons.component.scss'],
    providers: [KentekenPipe, CapitalizePipe],
})
export class InsuranceIMICButtonsComponent implements OnInit, AfterViewInit {
    @Input() purchasedProduct: PurchasedProductInterface;

    public downloadSuccess: boolean = false;
    public emailSuccess: boolean = false;
    public errors: ErrorInterface[] = [];
    public warningText: string;
    public productIdEnum = PolicyProductIdEnum;
    public isDisabled = false;

    constructor(private kentekenPipe: KentekenPipe, private capitalizePipe: CapitalizePipe) {
    }

    public ngOnInit(): void {
        this.isDisabled = this.setDisabled();
    }

    public ngAfterViewInit(): void {
        switch (this.purchasedProduct?.productId) {
            case PolicyProductIdEnum.Car:
                this.warningText = `Zodra u een ingangsdatum voor verzekering ${this.kentekenPipe.transform(this.purchasedProduct?.product?.car.licensePlate)} heeft opgegeven kunt u hier de Groene Kaart downloaden.`;
                break;
            case PolicyProductIdEnum.Moped:
                this.warningText = `Zodra u een ingangsdatum voor verzekering ${this.kentekenPipe.transform(this.purchasedProduct?.product?.moped?.licensePlate)} heeft opgegeven kunt u hier de Groene Kaart downloaden.`;
                break;
            case PolicyProductIdEnum.Motorcycle:
                this.warningText = `Zodra u een ingangsdatum voor verzekering ${this.capitalizePipe.transform(this.purchasedProduct?.product?.motorcycle?.motorVehicleMake)} heeft opgegeven kunt u hier de Groene Kaart downloaden.`;
                break;
            case PolicyProductIdEnum.Caravan:
                this.warningText = `        Zodra u een ingangsdatum voor verzekering ${this.kentekenPipe.transform(this.purchasedProduct?.product?.caravan?.licensePlate)} heeft opgegeven kunt u hier de Groene Kaart downloaden.`;
                break;
        }
    }

    public loadDownloadSuccess($event: boolean): void {
        this.downloadSuccess = $event;
    }

    public loadEmailSuccess($event: boolean): void {
        this.emailSuccess = $event;
    }

    public loadError(error: ErrorInterface[]): void {
        this.errors = error;
    }

    private setDisabled(): boolean {
        return this.purchasedProduct?.product?.validityStatusCode === PolicyValidityStatusCodeEnum.Transfer;
    }
}
